/**
 * Reload the video source
 * Only if the source is currently loaded.
 * @param videoElement
 */
function reloadVideoWhenLoaded(videoElement) {
    if (videoElement.readyState === 4) {
        videoElement.load();
        videoElement.play();
    } else {
        videoElement.addEventListener('load', () => reloadVideoWhenLoaded(videoElement), {once: true});
    }
}

/**
 * Reload videos on resize
 */
window.addEventListener('resize', () => {
    document.querySelectorAll('.stage-video video').forEach((videoElement) => {
        reloadVideoWhenLoaded(videoElement);
    });
});

/**
 * Set media queries on sources when breakpoints are loaded
 */
window.addEventListener('load', () => {
    const stageVideoElements = document.querySelectorAll('.stage-video video');
    if (stageVideoElements.length > 0) {
        const bodyStyles = window.getComputedStyle(document.body);
        const stageVideoMobileMediaQuery = bodyStyles.getPropertyValue('--stage-video-mobile-breakpoint');

        stageVideoElements.forEach((videoElement) => {
            videoElement.querySelectorAll('source.media-mobile').forEach((source) => {
                source.media = `(${stageVideoMobileMediaQuery})`;
            });
            reloadVideoWhenLoaded(videoElement);
        });
    }
}, {
    once: true,
});
